import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";
// import ReactDOM from 'react-dom';

import {Animated} from "react-animated-css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import Layout from "../components/layout";
import wsj from "../../static/images/news/wsj.svg";
import forbes from "../../static/images/news/forbes.svg";
import mckinsey from "../../static/images/news/mckinsey.svg";
import deloitte from "../../static/images/news/deloitte.svg";
import ibm from "../../static/images/news/ibm.svg";
import accenture from "../../static/images/news/accenture.svg";
import mit from "../../static/images/news/mit.svg";
import unilever from "../../static/images/news/unilever.svg";
import generalElectric from "../../static/images/news/general_electric.svg";
import phys from "../../static/images/news/phys.svg";
import siemens from "../../static/images/news/siemens.svg";
import dhl from "../../static/images/news/dhl.svg";
import chevron from "../../static/images/news/chevron.svg";

import { getVisiblePercentage } from "../utilities/elementUtilities";

import { assignActiveElementNew, visibilityObject, changeSlideInClass } from "../utilities/elementUtilities";


class DigitalTwinNews extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    this.handleScroll();
  }

  handleScroll = () => {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width > 700) {
      var news_heading = document.getElementById('news-heading');

      let percentage = getVisiblePercentage(news_heading);

      /*
        based on value of percentage change style of dots
      */

      var navigationDots = document.querySelectorAll("a.dot-link");
      // console.log(navigationDots);
      for (var i = 0, max = navigationDots.length; i < max; i++) {
        if (percentage > 5) {
          navigationDots[i].className = navigationDots[i].className.replace(/\bnews\b/g, "");
        } else {
          navigationDots[i].classList.add("news");
        }
      }

    }

    // var sectionList = [
    //   document.getElementById('news-organizations'),
    //   document.getElementById('news-industry'),
    //   document.getElementById('news-academia'),
    //   document.getElementById('news-consulting'),
    // ];
    // assignActiveElement(sectionList);

    var sectionList = [
      visibilityObject(document.getElementById('news-organizations')),
      visibilityObject(document.getElementById('news-industry')),
      visibilityObject(document.getElementById('news-academia')),
      visibilityObject(document.getElementById('news-consulting'))
    ];
    assignActiveElementNew(sectionList);

    changeSlideInClass();

  }

  render() {
    return(  
      <Layout footerMargin={false} layoutClassName="digital-twin-news" id="digital-twin-news">
        <div className="side-dots-nav">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="news-heading"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="news-organizations"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="news-industry"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="news-academia"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="news-consulting"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
          </ul>
        </div>
        <div id="news_parent" ref={ ref => this.news_parent = ref}>
          <section className="section news-heading full first" id="news-heading"  ref={ ref => this.news_heading = ref}>
            <p className="heading">AI products in the news.</p>
          </section>
          <section className="section news display" id="news-content" ref={ ref => this.news_content = ref}>
            <Row>
              <Col sm="12">
                <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
                  <section id="news-organizations" className="sectionDiv">
                    <Row>
                      <Col lg="3" sm="12" className="news-section-header" id="news-organizations-label">
                        <h2>News Organizations</h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={wsj} alt="WSJ" />
                          </div>
                          <p className="news-link">
                            <a href="https://blogs.wsj.com/cio/2018/09/12/digital-twins-concept-gains-traction-among-enterprises/" target="_blank" rel="noopener noreferrer">
                              Digital Twins Concept Gains Traction Among Enterprises
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={forbes} alt="Forbes" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.forbes.com/sites/bernardmarr/2019/04/23/7-amazing-examples-of-digital-twin-technology-in-practice/#74727c996443" target="_blank" rel="noopener noreferrer">
                              7 Amazing Examples of Digital Twin Technology In Practice
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </section>
                </Animated>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
                  <section id="news-industry" className="sectionDiv">
                    <Row>
                      <Col lg="3" sm="12" className="news-section-header" id="news-industry-label">
                        <h2>Industry</h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={chevron} alt="Chevron" />
                          </div>
                          <p className="news-link">
                            <a href="https://blogs.wsj.com/cio/2018/09/05/chevron-launching-predictive-maintenance-to-oil-fields-refineries/" target="_blank" rel="noopener noreferrer">
                              Chevron Launching Predictive Maintenance to Oil Fields, Refineries
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={unilever} alt="Unilever" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.wsj.com/articles/unilever-uses-virtual-factories-to-tune-up-its-supply-chain-11563206402" target="_blank" rel="noopener noreferrer">
                              Improving manufacturing operations
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={generalElectric} alt="General Electric" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.ge.com/digital/applications/digital-twin" target="_blank" rel="noopener noreferrer">
                              Digitize assets and processes to enable better industrial outcomes
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={siemens} alt="Siemens" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.rtinsights.com/how-siemens-employs-ai-to-build-its-digital-twin/" target="_blank" rel="noopener noreferrer">
                              Improving Time to Market
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={dhl} alt="DHL" />
                          </div>
                          <p className="news-link">
                            <a href="https://logisticsofthings.dhl/5-ways-digital-twinning-will-revolutionize-logistics/" target="_blank" rel="noopener noreferrer">
                              Optimizing Supply Chains
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </section>
                </Animated>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
                  <section id="news-academia" className="sectionDiv">
                    <Row>
                      <Col lg="3" sm="12" className="news-section-header" id="news-academia-label">
                        <h2>Academia</h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={mit} alt="MIT Technology Review" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.technologyreview.com/s/607962/general-electric-builds-an-ai-workforce/" target="_blank" rel="noopener noreferrer">
                              AI Workforce
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={phys} alt="Phys Org" />
                          </div>
                          <p className="news-link">
                            <a href="https://phys.org/news/2019-02-virtually-reality-future-factories-digital.html" target="_blank" rel="noopener noreferrer">
                              Virtually reality: Future factories run by digital twins
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </section>
                </Animated>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
                  <section id="news-consulting" className="sectionDiv">
                    <Row>
                      <Col lg="3" sm="12" className="news-section-header" id="news-consulting-label">
                        <h2>Consulting</h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={deloitte} alt="Deloitte" />
                          </div>
                          <p className="news-link">
                            <a href="https://www2.deloitte.com/us/en/insights/focus/industry-4-0/digital-twin-technology-smart-factory.html" target="_blank" rel="noopener noreferrer">
                              Industry 4.0 and the digital twin
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={accenture} alt="accenture" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.accenture.com/us-en/blogs/blogs-kass-tung-digital-twin" target="_blank" rel="noopener noreferrer">
                              What's a Digital Twin
                            </a>
                          </p>
                        </div>
                      </Col>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={mckinsey} alt="McKinsey" />
                          </div>
                          <p className="news-link">
                            <a href="https://www.mckinsey.com/~/media/McKinsey/Business%20Functions/McKinsey%20Digital/Our%20Insights/The%20next%20horizon%20for%20industrial%20manufacturing/The-next-horizon-for-industrial-manufacturing.ashx" target="_blank" rel="noopener noreferrer">
                              The next horizon for industrial manufacturing
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="12" xs="12" className="mb-5">
                        <div className="news-box">
                          <div className="image">
                            <img src={ibm} alt="IBM" />
                          </div>
                          <p className="news-link">
                            <a href="https://developer.ibm.com/articles/digital-twins-and-the-internet-of-things/" target="_blank" rel="noopener noreferrer">
                              Digital twins and the Internet of Things
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </section>
                </Animated>
              </Col>
            </Row>
          </section>
        </div>
      </Layout>
    );
  }
}

export default (DigitalTwinNews);